import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Box,
  ClearIcon,
  Flex,
  Input,
  RefreshIcon,
  Text,
  TextButton,
} from '@modusign/design-system';
import { ChangeEvent, useCallback, useState } from 'react';

interface MemberSearchBarProps {
  placeholder?: string;
  resultCount: number;
  searchKeyword: string;
  title: string;
  onReset(): void;
  onSetSearchKeyword(value: string): void;
}

export default function MemberSearchBar({
  placeholder = '이름 또는 이메일로 검색',
  resultCount,
  searchKeyword,
  title,
  onReset,
  onSetSearchKeyword,
}: MemberSearchBarProps) {
  const [searchValue, setSearchValue] = useState<string>('');

  const handleReset = useCallback(() => {
    onReset();
    setSearchValue('');
  }, [onReset]);

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
    onSetSearchKeyword(e.target.value);
  };

  return (
    <Flex
      alignItems={['flex-start', null, 'center']}
      flexDirection={['column', null, 'row']}
      justifyContent="space-between"
      mb={[6, null, 7]}
    >
      <Box order={[1, null, 0]}>
        {searchKeyword ? (
          <Flex alignItems="center">
            검색 결과
            <Text color="textEmphasisBase" fontWeight="medium" ml="2px">
              ({resultCount}명)
            </Text>
            <TextButton onClick={handleReset}>
              <RefreshIcon color="textNeutralLight" ml={3} mr="2px" />
              검색 초기화
            </TextButton>
          </Flex>
        ) : (
          <Text>
            {title} <Text fontWeight="medium">{resultCount}명</Text>
          </Text>
        )}
      </Box>
      <Box mb={[4, null, 0]} position="relative" width={[1, null, '40%']}>
        <Box
          as="button"
          color="textNeutralVeryLight"
          lineHeight="1.3em"
          sx={{ position: 'absolute', top: 3, left: 4 }}
          type="button"
          onClick={() => {}}
        >
          <FontAwesomeIcon icon={faSearch} style={{ height: '14px', width: '14px' }} />
        </Box>
        <Input
          placeholder={placeholder}
          sx={{ paddingLeft: '30px' }}
          value={searchValue}
          onChange={handleInputChange}
        />
        <Box
          as="button"
          sx={{
            position: 'absolute',
            right: 3,
            top: 2,
          }}
          onClick={handleReset}
        >
          {searchValue && <ClearIcon />}
        </Box>
      </Box>
    </Flex>
  );
}
